import { useGetHeroImage } from "./utils/useGetHeroImage";
import "./index.scss";

export const HeaderBrandDetails = ({ iconUrl }) => {
  const {
    images: { img, retinaImg, sources },
    logoClasses
  } = useGetHeroImage();

  return (
    <div className="hero-img-wrapper">
      <picture>
        {sources}
        <img
          src={img}
          srcSet={`${retinaImg} 2x`}
          className="hero-img"
          alt="brand banner"
          width={288}
          height={37}
          loading="lazy"
          importance="high"
          decoding="async"
        />
        <div className="hero-image-container">
          <img
            src={iconUrl ?? "/assets/brandPlaceholder.png"}
            className={logoClasses}
            alt="brand logo"
          />
        </div>
      </picture>
    </div>
  );
};
